import React from "react";
import "./App.css";
import Home from "./component/home";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap/dist/css/bootstrap.css";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Moreprofile from "./component/Moreprofile";
import Moredetail from "./component/Moredetail";
import Dashboard from "./component/Dashboard";
import Login from "./component/Login";
import RegisterAndDetail from "./component/RegisterAndDetail";
import Settings from "./component/Settings";
import Notification from "./component/Notification";
import LikedProfiles from "./component/LikedProfiles";
import MyProfile from "./component/MyProfile";
import MembershipPlans from "./component/MembershipPlans";

// 🔐 Basic Protection - Right Click Disable
const disableRightClick = (e) => {
  e.preventDefault();
  return false;
};

// 🔐 Basic Protection - Disable Text Selection
const disableTextSelection = (e) => {
  e.preventDefault();
  return false;
};

// 🔐 Basic Protection - Disable Copy/Paste/Cut
const disableCopyPaste = (e) => {
  e.preventDefault();
  return false;
};

// 🔐 Basic Protection - Disable Developer Tools (F12, Ctrl+Shift+I, etc.)
const disableDevTools = (e) => {
  // F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U
  if (e.keyCode === 123 || // F12
      (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74)) || // Ctrl+Shift+I/J
      (e.ctrlKey && e.keyCode === 85)) { // Ctrl+U (View Source)
    e.preventDefault();
    return false;
  }
};

const App = () => {
  // Apply protection when component mounts
  React.useEffect(() => {
    // Disable right click
    document.addEventListener('contextmenu', disableRightClick);
    
    // Disable text selection
    document.addEventListener('selectstart', disableTextSelection);
    document.addEventListener('dragstart', disableTextSelection);
    
    // Disable copy/paste/cut
    document.addEventListener('copy', disableCopyPaste);
    document.addEventListener('paste', disableCopyPaste);
    document.addEventListener('cut', disableCopyPaste);
    
    // Disable developer tools shortcuts
    document.addEventListener('keydown', disableDevTools);
    
    // Additional protection - Disable inspect element
    document.addEventListener('keydown', (e) => {
      if (e.key === 'F12' || (e.ctrlKey && e.shiftKey && e.key === 'I')) {
        e.preventDefault();
        return false;
      }
    });

    // Cleanup on unmount
    return () => {
      document.removeEventListener('contextmenu', disableRightClick);
      document.removeEventListener('selectstart', disableTextSelection);
      document.removeEventListener('dragstart', disableTextSelection);
      document.removeEventListener('copy', disableCopyPaste);
      document.removeEventListener('paste', disableCopyPaste);
      document.removeEventListener('cut', disableCopyPaste);
      document.removeEventListener('keydown', disableDevTools);
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
         {/* Default Route */}
        <Route path="/" element={<Navigate to="/home" />} />
        <Route path="*" element={<Navigate to="/login" />} />

        {/* Public Routes */}
        <Route path="/home" element={<Home />} />        
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<RegisterAndDetail />} />
        {/* Protected Routes */}
        <Route path="/rishteydashboard" element={<Dashboard />} />
        <Route path="/profile" element={<Moreprofile />} />
        <Route path="/moredetail/:id" element={<Moredetail />} />
        <Route path="/myprofile" element={<MyProfile />} />
        <Route path="/setting" element={<Settings />} />
        <Route path="/liked" element={<LikedProfiles />} />
        <Route path="/notification" element={<Notification />} />
        <Route path="/membership" element={<MembershipPlans />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
